import { Component, Prop } from 'vue-property-decorator'
import { mapGetters, mapMutations } from 'vuex'
// components
import { ModalLayout } from '@appbase/templates'
import HrView from './hr/HrView.vue'
import { OrgmapMainBase } from './OrgmapMainBase'
import * as types from '../store/types'
import { WishListContainer } from '../containers'

export interface TOrgmapModalPayload {
  options: orgmap.TWishContainerOptions
  event: string
  props: orgmap.TWishItemPropsOptions
}

@Component({
  components: { ModalLayout, HrView, WishListContainer },
  computed: {
    ...mapGetters({
      containers: types.ORG_CONTAINER_REGISTER,
    }),    
  },
  methods: {
    ...mapMutations({
      setOptions: types.ORG_OPTION_SET,
      clearContainer : types.ORG_CONTAINER_CLEAR
    }),
  },
})
export default class OrgmapInitiModalView extends OrgmapMainBase {
  @Prop({ type : Object }) propVal!: TOrgmapModalPayload
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //


  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  setOptions!: (payload: orgmap.TWishContainerOptions) => void
  clearContainer! : () => void


  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  selectedDept:orgmap.TDepartmentTreeItem|null = null;

  created(){
    this.options = this.propVal.options
    this.setOptions(this.options)
    this.event = this.propVal.event
    this.propsOption = this.propVal.props
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  selectDept(dept:orgmap.TDepartmentTreeItem){
    this.selectedDept = dept
  }
  
  handleClose(){
    this.$emit('cancel')
    this.clearContainer()
  }

  handleSave(){
    this.processOk.bind(this, window)()
    this.$emit('save')
  }
}
